import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Modal from '@/components/modal'
import Faq from '../popups/faq'
import Terms from '../popups/terms'
import Privacy from '../popups/privacy'
import Contact from '../popups/contact'
import { prerenderRoutes, siteTitle } from '@/ssr/prerender-routes'

/*
	the /faq, /terms and /privacy routes: the popup content, rendered as a page of its own.

	these pages exist so each document has a URL a crawler can fetch and a link can point to.
	they are prerendered at build time (see src/entry-server.tsx), so their text is in the
	initial HTML. that is why they are pages and not a route that opens the popup: a Radix
	Dialog renders through a portal, which the server renders as nothing.

	the popups themselves stay where leaving the page would cost the user something (signup
	step 1, Settings).
*/
export type StaticPageKind = 'faq' | 'terms' | 'privacy'

export default function StaticPage({ kind }: { kind: StaticPageKind }) {
	const [contactOpen, setContactOpen] = useState(false)
	const openContact = () => setContactOpen(true)

	//	the prerendered HTML carries the right <title> on a direct load; this covers client-side navigation.
	//	on leaving, fall back to the site title, which is what every other route has.
	useEffect(() => {
		const title = prerenderRoutes.find(route => route.path === `/${kind}`)?.title
		if (title)
			document.title = title
		return () => { document.title = siteTitle }
	}, [kind])

	return (
		<div className="h-full w-full overflow-y-auto bg-[#FFFFFD] text-gray-800">
			<div className="container mx-auto max-w-3xl p-4">
				<nav className="mb-6">
					<Link to="/" className="text-rose-600 hover:text-rose-600/80">&larr; hangaround.live</Link>
				</nav>
				{kind === 'faq' && <Faq />}
				{kind === 'terms' && <Terms onOpenContact={openContact} />}
				{kind === 'privacy' && <Privacy onOpenContact={openContact} />}
			</div>
			<Modal open={contactOpen} onOpenChange={setContactOpen}>
				<Contact />
			</Modal>
			<Toaster />
		</div>
	)
}
